<ng-container *ngIf="text">
  <a *ngIf="externalUrl || internalUrl; else button" (click)="goToUrl()" rel="noopener noreferrer" class="link-text">
    <em *ngIf="iconClass && iconPosition === 'left'" class="link-img link-img--left {{ iconClass }}"></em>
    <span>{{ text }}</span>
    <em *ngIf="iconClass && iconPosition === 'right'" class="link-img link-img--right {{ iconClass }}"></em>
  </a>

  <ng-template #button>
    <button (click)="onClickEvent()" class="link-button link-text">
      <em *ngIf="iconClass && iconPosition === 'left'" class="link-img link-img--left {{ iconClass }}"></em>
      <span>{{ text }}</span>
      <em *ngIf="iconClass && iconPosition === 'right'" class="link-img link-img--right {{ iconClass }}"></em>
    </button>
  </ng-template>
</ng-container>
